import React from 'react';
import { Phone, Mail, ShieldCheck } from 'lucide-react';
export function LoanOfficerCard() {
  return <div className="bg-white rounded-2xl shadow-sm border border-gray-200 overflow-hidden" data-id="element-49">
      <div className="bg-[#1a3a2a] p-6 flex flex-col items-center text-center" data-id="element-50">
        <div className="relative mb-4" data-id="element-51">
          <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=256&q=80" alt="Sarah Mitchell" className="w-24 h-24 rounded-full object-cover border-4 border-white/20 shadow-sm" data-id="element-52" />
          <div className="absolute bottom-0 right-0 bg-green-400 w-5 h-5 rounded-full border-2 border-[#1a3a2a] flex items-center justify-center" title="Online" data-id="element-53">
            <div className="w-2 h-2 bg-white rounded-full" data-id="element-54"></div>
          </div>
        </div>
        <h2 className="text-xl font-semibold text-white" data-id="element-55">Sarah Mitchell</h2>
        <p className="text-green-200 font-medium text-sm mb-1" data-id="element-56">
          Senior Loan Officer
        </p>
        <div className="flex items-center text-xs text-green-300/80 font-medium bg-white/10 px-2 py-1 rounded-md mt-2" data-id="element-57">
          <ShieldCheck className="w-3 h-3 mr-1" data-id="element-58" />
          NMLS #123456
        </div>
      </div>

      <div className="p-6" data-id="element-59">
        <p className="text-sm text-gray-600 leading-relaxed mb-6 italic" data-id="element-60">
          "Welcome! Please upload the documents below to keep your loan on
          track. Reach out if you have any questions."
        </p>

        <div className="space-y-4" data-id="element-61">
          <a href="tel:+15551234567" className="flex items-center text-sm text-gray-600 hover:text-green-700 transition-colors group" data-id="element-62">
            <div className="w-8 h-8 rounded-full bg-green-50 flex items-center justify-center mr-3 group-hover:bg-green-100 transition-colors" data-id="element-63">
              <Phone className="w-4 h-4 text-green-600" data-id="element-64" />
            </div>
            (555) 123-4567
          </a>
          <a href="mailto:sarah.m@mortgage.com" className="flex items-center text-sm text-gray-600 hover:text-green-700 transition-colors group" data-id="element-65">
            <div className="w-8 h-8 rounded-full bg-green-50 flex items-center justify-center mr-3 group-hover:bg-green-100 transition-colors" data-id="element-66">
              <Mail className="w-4 h-4 text-green-600" data-id="element-67" />
            </div>
            sarah.m@mortgage.com
          </a>
        </div>
      </div>
    </div>;
}